export default __webpack_public_path__ + "static/media/1480.41bd776f.png";